export default __webpack_public_path__ + "static/abmg-nav-logo-with-icon-default-1b4cea92e7690763cacfe47b0004a611.svg";